import { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import { getConnectionStats } from '../../../services/connection-stats.service';
import { ConnectionStatsDto } from '../../../services/dtos/connection-stats.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { showAxiosMessageError } from '../../../utils/error-message.util';

//Nombre de jours de tendance affichés sur la courbe
const TREND_DAYS = 30;

/**
 * Formate une date 'YYYY-MM-DD' en 'DD/MM/YYYY'
 * @param isoDate date au format ISO
 */
const formatDate = (isoDate: string) => {
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
};

/**
 * Panel admin des statistiques de connexion : compteur de la veille et courbe de tendance
 * @constructor
 */
export default function ConnectionsPage() {
    //SnackBar
    const showMessage = useSnackbars();
    //Statistiques de connexion
    const [stats, setStats] = useState<ConnectionStatsDto>();

    useEffect(() => {
        let isMounted = true;
        getConnectionStats(TREND_DAYS)
            .then(result => {
                isMounted && setStats(result);
            })
            .catch(error => {
                showAxiosMessageError(error, showMessage);
            });
        return () => {
            isMounted = false;
        };
    }, [showMessage]);

    if (!stats) {
        return <Skeleton variant="rectangular" height={300} />;
    }

    return (
        <Box>
            <Typography variant="h4">Connexions</Typography>
            <Box sx={{ marginBottom: 3 }}>
                <Typography variant="h5">
                    Connexions hier {stats.yesterday.date && `(${formatDate(stats.yesterday.date)})`}
                </Typography>
                <Typography variant="h3" data-testid="connections-yesterday-count">
                    {stats.yesterday.count}
                </Typography>
            </Box>
            <LineChart
                height={300}
                xAxis={[
                    {
                        data: stats.series.map(day => formatDate(day.date)),
                        scaleType: 'point',
                        label: 'Date',
                    },
                ]}
                series={[
                    {
                        data: stats.series.map(day => day.count),
                        label: 'Connexions',
                        color: '#3766A5',
                    },
                ]}
            />
        </Box>
    );
}
